import { render, staticRenderFns } from "./dynamicTable.vue?vue&type=template&id=20318832&scoped=true&"
import script from "./dynamicTable.vue?vue&type=script&lang=js&"
export * from "./dynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./dynamicTable.vue?vue&type=style&index=0&id=20318832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20318832",
  null
  
)

export default component.exports